import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import LatestNews from './components/LatestNews';
import TrendingTopics from './components/TrendingTopics';

export default function Home() {
  useEffect(() => {
    document.title = '17吃瓜网 - 最新娱乐八卦吃瓜资讯平台';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', '17吃瓜网是专注娱乐八卦、明星动态、热门瓜料的资讯聚合平台，每日更新最新吃瓜内容，涵盖影视圈、音乐圈、网红圈等全领域热点事件，带你第一时间吃到最劲爆的瓜。');
    }
    const metaKw = document.querySelector('meta[name="keywords"]');
    if (metaKw) {
      metaKw.setAttribute('content', '17吃瓜网,吃瓜网站,娱乐八卦资讯,明星八卦爆料,最新吃瓜爆料,网红热点事件,娱乐圈瓜料');
    }
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <LatestNews />
        <TrendingTopics />

        <section className="py-12 md:py-16 bg-primary-500">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">不错过任何一个瓜</h2>
            <p className="text-white/80 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
              关注17吃瓜网，第一时间获取最新娱乐八卦资讯。每日更新，精彩不断！
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="#newsletter"
                className="px-6 py-3 rounded-lg bg-white text-primary-600 font-semibold text-sm hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap"
              >
                订阅每日吃瓜
              </a>
              <a
                href="mailto:tips@17chigua.com"
                className="px-6 py-3 rounded-lg bg-white/20 text-white font-medium text-sm hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap"
              >
                爆料投稿
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}